// export default class {
//   constructor({ triggerSelector = '.accordion__trigger', transitionMs = 1000 } = {}) {
//     this.roots = document.querySelectorAll(triggerSelector)
//     if (!this.roots.length) return

//     this.triggerSelector = triggerSelector
//     this.transitionMs = transitionMs

//     this.init()
//   }

//   init() {
//     document.querySelectorAll(this.triggerSelector).forEach((trigger) => {
//       trigger.addEventListener('click', () => {
//         setTimeout(() => {
//           window.dispatchEvent(new Event('resize'))
//         }, this.transitionMs)
//       })
//     })
//   }
// }

export default class Accordion {
  constructor({ selector = '.accordion', transitionMs = 480 } = {}) {
    this.roots = [...document.querySelectorAll(selector)]
    if (!this.roots.length) return

    this.transitionMs = transitionMs
    this.onResize = this.syncOpenPanels.bind(this)

    this.bind()
    this.init()

    window.addEventListener('resize', this.onResize)
  }

  bind() {
    this.roots.forEach((root) => {
      root
        .querySelectorAll('details.accordion__item > summary.accordion__trigger')
        .forEach((summary) => {
          summary.addEventListener('click', (e) => {
            e.preventDefault()
            const item = summary.parentElement
            this.toggle(item)
          })
        })
    })
  }

  init() {
    this.roots.forEach((root) => {
      root.querySelectorAll('details.accordion__item').forEach((item) => {
        const panel = this.getPanel(item)
        if (!panel) return

        panel.style.display = 'block'
        panel.style.overflow = 'hidden'
        panel.style.transition = `height ${this.transitionMs}ms cubic-bezier(0.22, 1, 0.36, 1)`
        panel.style.height = item.open ? 'auto' : '0px'
      })
    })

    this.syncOpenPanels()
  }

  toggle(item) {
    if (item.open) {
      this.close(item)
      return
    }

    this.open(item)
  }

  getPanel(item) {
    return item.querySelector(':scope > .accordion__panel')
  }

  open(item) {
    const panel = this.getPanel(item)
    if (!panel || panel.dataset.animating === '1') return

    panel.dataset.animating = '1'
    item.open = true

    this.animateHeight(panel, 0, panel.scrollHeight, () => {
      panel.style.height = 'auto'
      panel.dataset.animating = '0'
      this.dispatchResize()
    })

    this.dispatchResize()
  }

  close(item) {
    const panel = this.getPanel(item)
    if (!panel || panel.dataset.animating === '1') return

    panel.dataset.animating = '1'

    const currentHeight = panel.getBoundingClientRect().height || panel.scrollHeight

    this.animateHeight(panel, currentHeight, 0, () => {
      item.open = false
      panel.dataset.animating = '0'
      panel.style.height = '0px'
      this.dispatchResize()
    })

    this.dispatchResize()
  }

  animateHeight(panel, fromHeight, toHeight, onDone) {
    panel.style.height = `${fromHeight}px`
    panel.offsetHeight

    requestAnimationFrame(() => {
      panel.style.height = `${toHeight}px`
    })

    this.onPanelTransitionEnd(panel, onDone)
  }

  onPanelTransitionEnd(panel, callback) {
    let done = false

    const finish = () => {
      if (done) return
      done = true
      panel.removeEventListener('transitionend', onEnd)
      window.clearTimeout(timeout)
      callback()
    }

    const onEnd = (event) => {
      if (event.target !== panel || event.propertyName !== 'height') return
      finish()
    }

    const timeout = window.setTimeout(finish, this.transitionMs + 120)
    panel.addEventListener('transitionend', onEnd)
  }

  syncOpenPanels() {
    this.roots.forEach((root) => {
      root.querySelectorAll('details.accordion__item[open]').forEach((item) => {
        const panel = this.getPanel(item)
        if (!panel || panel.dataset.animating === '1') return

        panel.style.height = 'auto'
      })
    })
  }

  dispatchResize() {
    window.requestAnimationFrame(() => {
      window.dispatchEvent(new Event('resize'))
    })
  }
}
